export default {
  GET_PAIR_COIN_SCALES: (state) => state.pairCoinScales,
};
